import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Table from "react-bootstrap/Table";
import EditIcon from "@mui/icons-material/Edit";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

const BlogDisplay = () => {
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const moreDetails = (id, item) => {
    navigate(id, { state: item });
  };

  const getBlogData = () => {
    axios
      .get(
        "https://us-central1-btay-project-1551779459124.cloudfunctions.net/AY/get/blogs"
        // "https://qrs.btartisticyoga.com/magicFood/getAllActiveBlogsForAdmin/"
      )
      .then((res) => {
        setBlogs(res.data.data || []);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    getBlogData();
  }, []);

  const updateBlog = async (item, nextIsActive) => {
    const obj = {
      title: item.title,
      description: item.description,
      isActive: nextIsActive,
      subtitle: item.subtitle ?? item.subtitle,
      image: item?.imageAssets,
      category: item.category,
      coverImage: item.coverImage,
    };

    await fetch(
      // "http://127.0.0.1:8000/magicFood/updateBlogs/",
      `https://us-central1-btay-project-1551779459124.cloudfunctions.net/AY/update/blog/${item.id}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(obj),
        redirect: "follow",
      }
    )
      .then((response) => response.json())
      .then(() => {
        getBlogData();
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const updateDisplayRank = async (id, rank) => {
    const obj = { blogId: id, displayRank: rank };

    await fetch(
      // "http://127.0.0.1:8000/magicFood/changeDisplayRankingByIdForBlog/",
      "https://qrs.btartisticyoga.com/magicFood/changeDisplayRankingByIdForBlog/",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(obj),
        redirect: "follow",
      }
    )
      .then((response) => response.json())
      .then(() => {
        // no-op; we'll refresh after the loop in drag handler
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const handleDragEnd = async (result) => {
    if (!result.destination) return;

    const sourceIndex = result.source.index;
    const destinationIndex = result.destination.index;
    if (sourceIndex === destinationIndex) return;

    const reordered = Array.from(blogs);
    const [moved] = reordered.splice(sourceIndex, 1);
    reordered.splice(destinationIndex, 0, moved);

    // Optimistic UI
    setBlogs(reordered);

    // Persist ranks sequentially (1-based)
    try {
      await Promise.all(
        reordered.map((item, idx) => updateDisplayRank(item.id, idx + 1))
      );
      getBlogData();
    } catch (e) {
      console.log(e);
    }
  };

  if (loading) {
    return (
      <div className="fp-Container">
        <Loader type="TailSpin" color="#FE5266" height={30} width={30} />
      </div>
    );
  }


  const handleDeleteBlog = async (id) => {
    if (!window.confirm("Are you sure you want to delete this blog?")) return;
  
    try {
      const res = await axios.delete(
        `https://us-central1-btay-project-1551779459124.cloudfunctions.net/AY/delete/blog/${id}`
      );
      alert(res.data.response);
      getBlogData()
    } catch (err) {
      console.error("Delete failed:", err.response?.data || err.message);
      alert("Failed to delete blog");
    }
  };

  return (
    <>
      <div className="QuickReads pb-5">
        <div className="quickReadsParentContainer">
          <div className="breadcrumbcontainer mb-5">
            <div className="breadcrumb-nav1">
              <span> Blogs</span>
              <Link to={"/create-blog"}>
                <button className="addQuickRead">Post Blog</button>
              </Link>
            </div>
          </div>

          <Table striped hover>
            <thead>
              <tr>
                <th>Rank</th>
                <th>Image</th>
                <th>Name</th>
                <th>Actions</th>
                <th>Edit</th>
                <th>Details</th>
                <th>Delete</th>
              </tr>
            </thead>

            <DragDropContext onDragEnd={handleDragEnd}>
              <Droppable droppableId="quickReads">
                {(provided) => (
                  <tbody {...provided.droppableProps} ref={provided.innerRef}>
                    {blogs.map((item, index) => (
                      <Draggable
                        key={item.id.toString()}
                        draggableId={item.id.toString()}
                        index={index}
                      >
                        {(provided) => (
                          <tr
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <td>{index + 1}</td>
                            <td>
                              <img width="100px" src={item.coverImage} alt="" />
                            </td>
                            <td>{item.title}</td>
                            <td>
                              <div className="blogsSwitch">
                                <label className="switch">
                                  <div className="checkbox_container">
                                    <input
                                      type="checkbox"
                                      checked={Boolean(item.isActive)}
                                      onChange={() =>
                                        updateBlog(item, !item.isActive)
                                      }
                                    />
                                    <span
                                      className="slider round"
                                      style={
                                        item?.isActive
                                          ? { backgroundColor: "green" }
                                          : { backgroundColor: "red" }
                                      }
                                    ></span>
                                    <div
                                      className="round_circle"
                                      style={
                                        item?.isActive
                                          ? { right: "4px", transition: "all 0.2s ease-in-out" }
                                          : { left: "4px", transition: "all 0.2s ease-in-out" }
                                      }
                                    ></div>
                                  </div>
                                </label>
                                {/* <span style={{ color: "black", marginLeft: 8 }}>
                                  {item?.isActive ? "is Active" : "not Active"}
                                </span> */}
                              </div>
                            </td>
                            <td>
                              <Link to={`/update-blog/${item.id}`}>
                                <EditIcon style={{ cursor: "pointer", color: "black" }} />
                              </Link>
                            </td>
                            <td>
                              <img
                                onClick={() =>
                                  moreDetails(`/blog/${item.id}`, item)
                                }
                                style={{ cursor: "pointer" }}
                                src="/img/eye.png"
                                alt="image"
                                width={"30px"}
                              />
                            </td>
                            <td>
                            <svg onClick={()=>handleDeleteBlog(item.id)} style={{ cursor: "pointer" }} width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M10 12V17" stroke="#db0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M14 12V17" stroke="#db0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M4 7H20" stroke="#db0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M6 10V18C6 19.6569 7.34315 21 9 21H15C16.6569 21 18 19.6569 18 18V10" stroke="#db0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke="#db0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                            </td>
                          </tr>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </tbody>
                )}
              </Droppable>
            </DragDropContext>
          </Table>
        </div>
      </div>
    </>
  );
};

export default BlogDisplay;